import {
  withTranslation,
} from 'react-i18next';

import RegattaDescriptionSectionView from './RegattaDescriptionSectionView';

const TranslatedComponent = withTranslation()(RegattaDescriptionSectionView);

const Component = TranslatedComponent;

export default Component;
